
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[permalink]",
      function () {
        return require("private-next-pages/[permalink]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[permalink]"])
      });
    }
  